<template>
    <v-btn tile color="primary" @click="save">
      SALVAR COMO RASCUNHO
    </v-btn>
</template>

<script>
  export default {
    data: () => ({}),
    methods: {
      save: function () {
        this.$emit('saveAsDraft')
      }
    }
  }
</script>

<style lang="scss" scoped>
  #ajuda_dicas {
    button {
      min-height: 44px;
      margin-bottom: 16px;
      font-size: 12px !important;
      line-height: 44px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/poll/sideHelper/SideHelperPollCreateEdit.vue